import { GroupDividerLayout } from '@/components/table/group-divider-layout';
import { StartDateGroupKey } from '@/lib/table-grouping-utils';
import { formatShortDateWithDayOfWeek } from '@airreading/common';

interface TeacherSessionDateDividerProps {
  groupKey: StartDateGroupKey;
  rowCount: number;
}

export function TeacherSessionDateDivider({ groupKey, rowCount }: TeacherSessionDateDividerProps) {
  return (
    <GroupDividerLayout rowCount={rowCount}>
      {formatShortDateWithDayOfWeek(groupKey.instant, groupKey.timeZone)}
    </GroupDividerLayout>
  );
}
